import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import PayrollForm from '@/components/salary/PayrollForm.vue';
    import { useI18n } from 'vue-i18n';
    import QueryKey from '@/enums/QueryKey';
    import { today, getLocalTimeZone } from '@internationalized/date';
    import { toast } from 'vue-sonner';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePayroll',
  props: {
    selectedCompanyId: {}
  },
  setup(__props: any) {

    

    const { t } = useI18n();

    const currentDate = today(getLocalTimeZone());

    const form = useForm({
        type: 'primary',
        month: currentDate.month,
        year: currentDate.year,
        employeeIds: [],
    });

    const handleError = (error: any) => {
        if (error.info) {
            toast.success(error.info);
        } else {
            toast.error(t('forms.generic_error'));
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.salary.payrolls.store'),
    "query-key": [_unref(QueryKey).PAYROLLS, _ctx.selectedCompanyId],
    title: "salary.payroll.create",
    "button-text": "salary.payroll.create",
    "submit-text": "salary.payroll.start",
    "success-message": "payrolls.edit.created_success",
    "hide-error-toast": "",
    onError: handleError
  }, {
    default: _withCtx(() => [
      _createVNode(PayrollForm, {
        form: _unref(form),
        "selected-company-id": _ctx.selectedCompanyId
      }, null, 8, ["form", "selected-company-id"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})